<template>
    <portal to="modal-destination">
        <div ref="modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" style="background: rgba(26, 26, 26, 0.17);">
            <div class="modal-dialog" :class="{'modal-dialog-centered' : centered, [size]: true}" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="text-dark btn-clear mb-2 opacity-0 pe-none" data-dismiss="modal" aria-label="Close">
                            <i class="las la-times"></i>
                        </button>

                        <h5 class="modal-title flex-grow-1 text-center">
                            <slot name="modal-title"></slot>
                        </h5>
                        <button type="button" class="text-dark btn-clear mb-2" data-dismiss="modal" aria-label="Close">
                            <i class="las la-times"></i>
                        </button>
                    </div>
                    <slot></slot>
                    <!--                    <div class="modal-body">-->
                    <!--                        ...<i class="las la-times"></i>-->
                    <!--                    </div>-->
                    <!--                    <div class="modal-footer">-->
                    <!--                        <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>-->
                    <!--                        <button type="button" class="btn btn-secondary">Save changes</button>-->
                    <!--                    </div>-->
                </div>
            </div>
        </div>
    </portal>
</template>

<script>
export default {
    props: {
        open: {
            type: Boolean,
            default: false
        },
        id: {
            type: String,
        },
        centered: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'modal-small',
        }
    },
    beforeDestroy() {
        $(this.$refs.modal).remove();
    },
    methods: {
        openModal() {
            $(this.$refs.modal).modal({backdrop: false});
        },
        closeModal() {
            $(this.$refs.modal).modal('hide');
            this.$emit('close');
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-dialog {
    margin-top: max(30px, 7vh);
}

.modal-dialog.modal-small {
    max-width: 406px;
}

.modal-dialog.modal-medium {
    max-width: 700px;
}

.modal-content {
    border: 3px solid var(--juoda, #222);
    padding: 32px;
    border-radius: 0;
}

.modal-header, .modal-body, .modal-footer {
    padding: 0;
    border: none;
}

@media (width < 400px) {
    .modal-content {
        padding: 16px;
    }
}
</style>
